import React, {useState, useEffect} from 'react'
import {Steps, Step, useSteps, useStepsContext, Box} from '../../..'
import {ResetPrompt, StepButtons, Content} from '../../../src/components/Steps/stories/Steps.story-helpers'

const descriptionSteps = [
  {label: 'Step 1', description: 'Step 1 Description'},
  {label: 'Step 2 Label', description: 'Step 2 Description'},
  {label: 'Step 3', description: 'Step 3 Description'}
]

const StyledStepsExample = () => {
  const [domLoaded, setDomLoaded] = useState(false)
  useEffect(() => {
    setDomLoaded(true)
  }, [])
  const {nextStep, prevStep, reset, activeStep} = useSteps({
    initialStep: 0
  })
  const {size} = useStepsContext()
  return (
    <>
      {domLoaded && (
        <Box>
          <Steps size={size} activeStep={activeStep}>
            {descriptionSteps.map(({label, description}, index) => (
              <Step label={label} key={label} description={description}>
                <Content my={6} index={index} />
              </Step>
            ))}
          </Steps>
          <Box sx={{display: 'flex', gap: 3, px: 4, py: 2, justifyContent: 'flex-end', fontSize: 2}}>
            {activeStep === 3 ? (
              <ResetPrompt onReset={reset} />
            ) : (
              <StepButtons {...{nextStep, prevStep}} prevDisabled={activeStep === 0} />
            )}
          </Box>
        </Box>
      )}
    </>
  )
}
export default StyledStepsExample
